var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PermissionValidation',{attrs:{"marketId":_vm.marketId,"rule":"enableApproveAreaInterest"}},[_c('approve-list',{attrs:{"loading":_vm.isMainLoading},on:{"onInit":_vm.getApproveTasksByMarket}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }